import React from 'react';
import styled from 'styled-components';
import { Card } from 'antd';

const NewCardContainer = styled.div`
  .ant-card {
    border-radius: 4px;
    background-color: transparent;
  }

  .ant-card .ant-card-head {
    border-radius: 4px 4px 0 0;
    background-color: #84848452;
    backdrop-filter: blur(10px);
    padding: 0 20px;

    @media (max-width: 845px) {
      padding: 0 16px;
    }
  }

  .ant-card .header-card {
    display: flex;
    padding: 10px 0;
    gap: 10px;
  }

  .ant-card .header-card .header-card-actions {
    text-align: end;
    width: 100%;
  }

  .ant-card-body {
    background-color: white;
  }

  .ant-btn.button-clear-filters {
    width: 32px;
    height: 32px;
    color: '#2b3d54';
  }

  .ant-btn {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '1100px'}) {
      padding: 4px 0;
    }
  }

  .ant-table-wrapper .ant-table.ant-table-middle {
    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '1100px'}) {
      overflow-y: auto;
    }
  }

  .ant-table-thead > tr > th {
    text-align: center !important;
    vertical-align: middle !important;
  }

  .ant-table-thead > tr > th .ant-table-column-title {
    white-space: normal;
    text-align: center;
  }

  .ant-table-thead > tr > th .ant-table-column-sorters {
    justify-content: center;
  }
`;

const NewCard = ({
  header,
  actions,
  children,
  loading
}: {
  header?: JSX.Element;
  actions?: JSX.Element;
  children: JSX.Element;
  loading?: boolean;
}) => {
  return (
    <NewCardContainer>
      <Card
        loading={loading}
        title={
          <div className="header-card">
            {header}
            <div className="header-card-actions">{actions}</div>
          </div>
        }
      >
        {children}
      </Card>
    </NewCardContainer>
  );
};

export default NewCard;
